import { render, staticRenderFns } from "./HalfLayout.vue?vue&type=template&id=2684ea18&scoped=true"
import script from "./HalfLayout.vue?vue&type=script&setup=true&lang=ts"
export * from "./HalfLayout.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./HalfLayout.vue?vue&type=style&index=0&id=2684ea18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2684ea18",
  null
  
)

export default component.exports